import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import VueRecaptcha from 'vue-recaptcha';

@Component({
  components: { VueRecaptcha },
})
export default class RecaptchaV2Component extends Vue {
  @Prop(Boolean) public hasError!: boolean;

  public siteKey = process.env.VUE_APP_RECAPTCHA_V2_SITE_KEY || '';

  public created(): void {
    this.$root.$on('resetRecaptcha', this.resetRecaptcha);
  }

  public verify(response: string): void {
    this.$emit('verifyRecaptchaV2', response);
  }

  public expired(): void {
    this.$emit('expiredRecaptchaV2');
  }

  public resetRecaptcha(): void {
    if (this.$refs.invisibleRecaptcha2) {
      (this.$refs.invisibleRecaptcha2 as any).reset(); // Direct call reset method
    }
  }
}
